export default "__VITE_ASSET__Cj8LKjQk__"